import React from 'react';
import Layout from './layout/index';
const LayoutPureSSR = ({ children, isLoggedSSR, footerData, isSticky, showExtoleReferFriend, registrationFlow }) => (React.createElement(Layout, { isLoggedSSR: isLoggedSSR, isSticky: isSticky, footerData: footerData, showExtoleReferFriend: showExtoleReferFriend, registrationFlow: registrationFlow }, children));
export default LayoutPureSSR;
